import apiClient from "@/libs/apiClient"
import { API_URLS } from "./apiUrls"

export function apiGetReview() {
  const endpoint = API_URLS.getReviewUrl()

  return apiClient.get(endpoint, { useCache: true })
}

export function apiGetUserReview(productId) {
  const endpoint = API_URLS.getUserReviewUrl(productId)

  return apiClient.get(endpoint)
}

export function apiGetProductStats(productId) {
  const endpoint = API_URLS.getProductStatsUrl(productId)

  return apiClient.get(endpoint)
}

export function apiGetProductReviews(productId, queryParam) {
  const endpoint = API_URLS.getProductReviewsUrl(productId)

  return apiClient.get(endpoint, { params: queryParam })
}

export function apiGetProductReviewImages(queryParam) {
  // export function apiGetProductReviewImages() {
  const endpoint = API_URLS.getProductReviewImagesUrl()

  // return Promise.resolve({
  //   resultInfo: {
  //     transactionID: "1f8f58f2-91a7-40f1-9ba7-f7a82d0adc76",
  //     statusCode: "200",
  //     message: "OK",
  //     status: "SUCCESS",
  //   },
  //   data: {
  //     reviews: [
  //       {
  //         id: "6618ca0fb942130f7c1ebd9c",
  //         clientId: "tira",
  //         createdBy: "65e004a60b121a2150ae2e80",
  //         productId: "1014128",
  //         alternateCode1: "1014132",
  //         alternateCode2: "7511068",
  //         approvedAt: "2024-04-12T05:49:28.000+00:00",
  //         approvedBy: "657fc2d20eada8bf400bdca4",
  //         createdAt: "2024-04-12T05:44:54.000+00:00",
  //         customerName: "Venkateshwarlu Edukulla",
  //         title: "Beauty People Sheer Color Lipstick 512 (3.8gm)",
  //         content:
  //           "Beauty People Sheer Color Lipstick 512 (3.8gm) Beauty People Sheer Color Lipstick 512 (3.8gm) Review",
  //         verified: true,
  //         image: {
  //           id: "6618ca56b942130f7c1ebdd7",
  //           url: "https://reviews-ratings-widget-sit.jio.com/dev/c5f09104-a588-4507-9927-0329a880d39d_99..jpeg",
  //           lowResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/cdb9c24d-e09d-4210-9c5d-16a684036898_81..jpeg",
  //           midResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/e53d3a8e-ac5a-42c9-a023-4232db94168c_77..jpeg",
  //           highResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/c5f09104-a588-4507-9927-0329a880d39d_99..jpeg",
  //           status: "APPROVED",
  //         },
  //         imageList: [
  //           {
  //             id: "6618ca56b942130f7c1ebdd7",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/c5f09104-a588-4507-9927-0329a880d39d_99..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/cdb9c24d-e09d-4210-9c5d-16a684036898_81..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/e53d3a8e-ac5a-42c9-a023-4232db94168c_77..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/c5f09104-a588-4507-9927-0329a880d39d_99..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ca56b942130f7c1ebdd8",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/4fb3a695-e2bb-4c73-a0d2-12175e0c11ea_17..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/9a71fd68-e8ae-45a3-b40f-253f59b1b02d_30..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/6b744ff4-4f9f-40b6-9627-9878b5d3e112_63..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/4fb3a695-e2bb-4c73-a0d2-12175e0c11ea_17..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ca56b942130f7c1ebdd9",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/58220e11-bb5d-4092-9c86-5da5cd29023f_55..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/d9287b41-b81f-4fde-944a-9269b6e1d24b_8..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/a69c06ec-b332-4686-8b2a-6383baaba753_42..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/58220e11-bb5d-4092-9c86-5da5cd29023f_55..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ca56b942130f7c1ebdda",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/6f19337a-ce9a-43a2-bf6e-867eebac366f_52..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/59abcafc-ac6b-49d4-809d-667838247410_23..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/12cf370f-5141-445d-838a-ce5bbafac1b6_70..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/6f19337a-ce9a-43a2-bf6e-867eebac366f_52..jpeg",
  //             status: "APPROVED",
  //           },
  //         ],
  //         downvoteCount: 0,
  //         upvoteCount: 3,
  //         rating: 5,
  //         anonymous: false,
  //       },
  //       {
  //         id: "6618ca0fb942130f7c1ebd9c",
  //         clientId: "tira",
  //         createdBy: "65e004a60b121a2150ae2e80",
  //         productId: "1014128",
  //         alternateCode1: "1014132",
  //         alternateCode2: "7511068",
  //         approvedAt: "2024-04-12T05:49:28.000+00:00",
  //         approvedBy: "657fc2d20eada8bf400bdca4",
  //         createdAt: "2024-04-12T05:44:54.000+00:00",
  //         customerName: "Venkateshwarlu Edukulla",
  //         title: "Beauty People Sheer Color Lipstick 512 (3.8gm)",
  //         content:
  //           "Beauty People Sheer Color Lipstick 512 (3.8gm) Beauty People Sheer Color Lipstick 512 (3.8gm) Review",
  //         verified: true,
  //         image: {
  //           id: "6618ca56b942130f7c1ebdd8",
  //           url: "https://reviews-ratings-widget-sit.jio.com/dev/4fb3a695-e2bb-4c73-a0d2-12175e0c11ea_17..jpeg",
  //           lowResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/9a71fd68-e8ae-45a3-b40f-253f59b1b02d_30..jpeg",
  //           midResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/6b744ff4-4f9f-40b6-9627-9878b5d3e112_63..jpeg",
  //           highResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/4fb3a695-e2bb-4c73-a0d2-12175e0c11ea_17..jpeg",
  //           status: "APPROVED",
  //         },
  //         imageList: [
  //           {
  //             id: "6618ca56b942130f7c1ebdd7",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/c5f09104-a588-4507-9927-0329a880d39d_99..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/cdb9c24d-e09d-4210-9c5d-16a684036898_81..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/e53d3a8e-ac5a-42c9-a023-4232db94168c_77..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/c5f09104-a588-4507-9927-0329a880d39d_99..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ca56b942130f7c1ebdd8",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/4fb3a695-e2bb-4c73-a0d2-12175e0c11ea_17..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/9a71fd68-e8ae-45a3-b40f-253f59b1b02d_30..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/6b744ff4-4f9f-40b6-9627-9878b5d3e112_63..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/4fb3a695-e2bb-4c73-a0d2-12175e0c11ea_17..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ca56b942130f7c1ebdd9",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/58220e11-bb5d-4092-9c86-5da5cd29023f_55..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/d9287b41-b81f-4fde-944a-9269b6e1d24b_8..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/a69c06ec-b332-4686-8b2a-6383baaba753_42..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/58220e11-bb5d-4092-9c86-5da5cd29023f_55..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ca56b942130f7c1ebdda",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/6f19337a-ce9a-43a2-bf6e-867eebac366f_52..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/59abcafc-ac6b-49d4-809d-667838247410_23..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/12cf370f-5141-445d-838a-ce5bbafac1b6_70..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/6f19337a-ce9a-43a2-bf6e-867eebac366f_52..jpeg",
  //             status: "APPROVED",
  //           },
  //         ],
  //         downvoteCount: 0,
  //         upvoteCount: 3,
  //         rating: 5,
  //         anonymous: false,
  //       },
  //       {
  //         id: "6618ca0fb942130f7c1ebd9c",
  //         clientId: "tira",
  //         createdBy: "65e004a60b121a2150ae2e80",
  //         productId: "1014128",
  //         alternateCode1: "1014132",
  //         alternateCode2: "7511068",
  //         approvedAt: "2024-04-12T05:49:28.000+00:00",
  //         approvedBy: "657fc2d20eada8bf400bdca4",
  //         createdAt: "2024-04-12T05:44:54.000+00:00",
  //         customerName: "Venkateshwarlu Edukulla",
  //         title: "Beauty People Sheer Color Lipstick 512 (3.8gm)",
  //         content:
  //           "Beauty People Sheer Color Lipstick 512 (3.8gm) Beauty People Sheer Color Lipstick 512 (3.8gm) Review",
  //         verified: true,
  //         image: {
  //           id: "6618ca56b942130f7c1ebdd9",
  //           url: "https://reviews-ratings-widget-sit.jio.com/dev/58220e11-bb5d-4092-9c86-5da5cd29023f_55..jpeg",
  //           lowResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/d9287b41-b81f-4fde-944a-9269b6e1d24b_8..jpeg",
  //           midResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/a69c06ec-b332-4686-8b2a-6383baaba753_42..jpeg",
  //           highResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/58220e11-bb5d-4092-9c86-5da5cd29023f_55..jpeg",
  //           status: "APPROVED",
  //         },
  //         imageList: [
  //           {
  //             id: "6618ca56b942130f7c1ebdd7",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/c5f09104-a588-4507-9927-0329a880d39d_99..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/cdb9c24d-e09d-4210-9c5d-16a684036898_81..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/e53d3a8e-ac5a-42c9-a023-4232db94168c_77..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/c5f09104-a588-4507-9927-0329a880d39d_99..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ca56b942130f7c1ebdd8",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/4fb3a695-e2bb-4c73-a0d2-12175e0c11ea_17..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/9a71fd68-e8ae-45a3-b40f-253f59b1b02d_30..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/6b744ff4-4f9f-40b6-9627-9878b5d3e112_63..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/4fb3a695-e2bb-4c73-a0d2-12175e0c11ea_17..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ca56b942130f7c1ebdd9",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/58220e11-bb5d-4092-9c86-5da5cd29023f_55..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/d9287b41-b81f-4fde-944a-9269b6e1d24b_8..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/a69c06ec-b332-4686-8b2a-6383baaba753_42..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/58220e11-bb5d-4092-9c86-5da5cd29023f_55..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ca56b942130f7c1ebdda",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/6f19337a-ce9a-43a2-bf6e-867eebac366f_52..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/59abcafc-ac6b-49d4-809d-667838247410_23..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/12cf370f-5141-445d-838a-ce5bbafac1b6_70..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/6f19337a-ce9a-43a2-bf6e-867eebac366f_52..jpeg",
  //             status: "APPROVED",
  //           },
  //         ],
  //         downvoteCount: 0,
  //         upvoteCount: 3,
  //         rating: 5,
  //         anonymous: false,
  //       },
  //       {
  //         id: "6618ca0fb942130f7c1ebd9c",
  //         clientId: "tira",
  //         createdBy: "65e004a60b121a2150ae2e80",
  //         productId: "1014128",
  //         alternateCode1: "1014132",
  //         alternateCode2: "7511068",
  //         approvedAt: "2024-04-12T05:49:28.000+00:00",
  //         approvedBy: "657fc2d20eada8bf400bdca4",
  //         createdAt: "2024-04-12T05:44:54.000+00:00",
  //         customerName: "Venkateshwarlu Edukulla",
  //         title: "Beauty People Sheer Color Lipstick 512 (3.8gm)",
  //         content:
  //           "Beauty People Sheer Color Lipstick 512 (3.8gm) Beauty People Sheer Color Lipstick 512 (3.8gm) Review",
  //         verified: true,
  //         image: {
  //           id: "6618ca56b942130f7c1ebdda",
  //           url: "https://reviews-ratings-widget-sit.jio.com/dev/6f19337a-ce9a-43a2-bf6e-867eebac366f_52..jpeg",
  //           lowResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/59abcafc-ac6b-49d4-809d-667838247410_23..jpeg",
  //           midResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/12cf370f-5141-445d-838a-ce5bbafac1b6_70..jpeg",
  //           highResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/6f19337a-ce9a-43a2-bf6e-867eebac366f_52..jpeg",
  //           status: "APPROVED",
  //         },
  //         imageList: [
  //           {
  //             id: "6618ca56b942130f7c1ebdd7",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/c5f09104-a588-4507-9927-0329a880d39d_99..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/cdb9c24d-e09d-4210-9c5d-16a684036898_81..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/e53d3a8e-ac5a-42c9-a023-4232db94168c_77..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/c5f09104-a588-4507-9927-0329a880d39d_99..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ca56b942130f7c1ebdd8",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/4fb3a695-e2bb-4c73-a0d2-12175e0c11ea_17..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/9a71fd68-e8ae-45a3-b40f-253f59b1b02d_30..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/6b744ff4-4f9f-40b6-9627-9878b5d3e112_63..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/4fb3a695-e2bb-4c73-a0d2-12175e0c11ea_17..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ca56b942130f7c1ebdd9",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/58220e11-bb5d-4092-9c86-5da5cd29023f_55..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/d9287b41-b81f-4fde-944a-9269b6e1d24b_8..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/a69c06ec-b332-4686-8b2a-6383baaba753_42..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/58220e11-bb5d-4092-9c86-5da5cd29023f_55..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ca56b942130f7c1ebdda",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/6f19337a-ce9a-43a2-bf6e-867eebac366f_52..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/59abcafc-ac6b-49d4-809d-667838247410_23..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/12cf370f-5141-445d-838a-ce5bbafac1b6_70..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/6f19337a-ce9a-43a2-bf6e-867eebac366f_52..jpeg",
  //             status: "APPROVED",
  //           },
  //         ],
  //         downvoteCount: 0,
  //         upvoteCount: 3,
  //         rating: 5,
  //         anonymous: false,
  //       },
  //       {
  //         id: "6618cc5d1ff5f4712c973a87",
  //         clientId: "tira",
  //         createdBy: "65e004a60b121a2150ae2e80",
  //         productId: "1014128",
  //         alternateCode1: "1014134",
  //         alternateCode2: "7511071",
  //         approvedAt: "2024-04-12T07:00:56.000+00:00",
  //         approvedBy: "657fc2d20eada8bf400bdca4",
  //         createdAt: "2024-04-12T05:55:01.000+00:00",
  //         customerName: "Venkateshwarlu Edukulla",
  //         title: "Beauty People Sheer Color Lipstick 605 (3.8gm)",
  //         content: "Beauty People Sheer Color Lipstick 605 (3.8gm)",
  //         verified: true,
  //         image: {
  //           id: "6618ccb5353e9464dff5d522",
  //           url: "https://reviews-ratings-widget-sit.jio.com/dev/b8bf793d-916c-4151-baf1-3326e176faac_89..jpeg",
  //           lowResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/b46ab4dd-244b-4729-977d-aedfda1aff4b_12..jpeg",
  //           midResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/170b0d79-38bc-4581-9931-f4f4d323a64d_18..jpeg",
  //           highResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/b8bf793d-916c-4151-baf1-3326e176faac_89..jpeg",
  //           status: "APPROVED",
  //         },
  //         imageList: [
  //           {
  //             id: "6618ccb5353e9464dff5d522",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/b8bf793d-916c-4151-baf1-3326e176faac_89..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/b46ab4dd-244b-4729-977d-aedfda1aff4b_12..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/170b0d79-38bc-4581-9931-f4f4d323a64d_18..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/b8bf793d-916c-4151-baf1-3326e176faac_89..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ccb5353e9464dff5d523",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/5db5a603-2f71-4326-8379-10ff5cec8db7_50..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/fed3a34b-b106-4b89-9cba-0f9099a93828_77..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/c07b3baa-0795-43e5-a9a3-81c4d8d10587_31..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/5db5a603-2f71-4326-8379-10ff5cec8db7_50..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ccb5353e9464dff5d524",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/ec496909-8d49-4e58-a54b-e7f103bae49d_50..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/7feaf646-41a4-4fc0-984a-3204583d2e00_7..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/f4bc51c8-3ad5-4dbc-9146-974d7a3c19f0_63..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/ec496909-8d49-4e58-a54b-e7f103bae49d_50..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ccb5353e9464dff5d525",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/9b462e0c-1e98-48ac-81fc-a17b8f5f4b59_55..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/22342745-c88d-4de1-a77d-332386d73545_75..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/0eb89e77-0185-4817-b1bd-ec9bc6b42e6f_18..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/9b462e0c-1e98-48ac-81fc-a17b8f5f4b59_55..jpeg",
  //             status: "APPROVED",
  //           },
  //         ],
  //         downvoteCount: 0,
  //         upvoteCount: 3,
  //         rating: 4,
  //         anonymous: false,
  //       },
  //       {
  //         id: "6618cc5d1ff5f4712c973a87",
  //         clientId: "tira",
  //         createdBy: "65e004a60b121a2150ae2e80",
  //         productId: "1014128",
  //         alternateCode1: "1014134",
  //         alternateCode2: "7511071",
  //         approvedAt: "2024-04-12T07:00:56.000+00:00",
  //         approvedBy: "657fc2d20eada8bf400bdca4",
  //         createdAt: "2024-04-12T05:55:01.000+00:00",
  //         customerName: "Venkateshwarlu Edukulla",
  //         title: "Beauty People Sheer Color Lipstick 605 (3.8gm)",
  //         content: "Beauty People Sheer Color Lipstick 605 (3.8gm)",
  //         verified: true,
  //         image: {
  //           id: "6618ccb5353e9464dff5d523",
  //           url: "https://reviews-ratings-widget-sit.jio.com/dev/5db5a603-2f71-4326-8379-10ff5cec8db7_50..jpeg",
  //           lowResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/fed3a34b-b106-4b89-9cba-0f9099a93828_77..jpeg",
  //           midResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/c07b3baa-0795-43e5-a9a3-81c4d8d10587_31..jpeg",
  //           highResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/5db5a603-2f71-4326-8379-10ff5cec8db7_50..jpeg",
  //           status: "APPROVED",
  //         },
  //         imageList: [
  //           {
  //             id: "6618ccb5353e9464dff5d522",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/b8bf793d-916c-4151-baf1-3326e176faac_89..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/b46ab4dd-244b-4729-977d-aedfda1aff4b_12..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/170b0d79-38bc-4581-9931-f4f4d323a64d_18..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/b8bf793d-916c-4151-baf1-3326e176faac_89..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ccb5353e9464dff5d523",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/5db5a603-2f71-4326-8379-10ff5cec8db7_50..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/fed3a34b-b106-4b89-9cba-0f9099a93828_77..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/c07b3baa-0795-43e5-a9a3-81c4d8d10587_31..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/5db5a603-2f71-4326-8379-10ff5cec8db7_50..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ccb5353e9464dff5d524",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/ec496909-8d49-4e58-a54b-e7f103bae49d_50..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/7feaf646-41a4-4fc0-984a-3204583d2e00_7..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/f4bc51c8-3ad5-4dbc-9146-974d7a3c19f0_63..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/ec496909-8d49-4e58-a54b-e7f103bae49d_50..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ccb5353e9464dff5d525",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/9b462e0c-1e98-48ac-81fc-a17b8f5f4b59_55..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/22342745-c88d-4de1-a77d-332386d73545_75..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/0eb89e77-0185-4817-b1bd-ec9bc6b42e6f_18..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/9b462e0c-1e98-48ac-81fc-a17b8f5f4b59_55..jpeg",
  //             status: "APPROVED",
  //           },
  //         ],
  //         downvoteCount: 0,
  //         upvoteCount: 3,
  //         rating: 4,
  //         anonymous: false,
  //       },
  //       {
  //         id: "6618cc5d1ff5f4712c973a87",
  //         clientId: "tira",
  //         createdBy: "65e004a60b121a2150ae2e80",
  //         productId: "1014128",
  //         alternateCode1: "1014134",
  //         alternateCode2: "7511071",
  //         approvedAt: "2024-04-12T07:00:56.000+00:00",
  //         approvedBy: "657fc2d20eada8bf400bdca4",
  //         createdAt: "2024-04-12T05:55:01.000+00:00",
  //         customerName: "Venkateshwarlu Edukulla",
  //         title: "Beauty People Sheer Color Lipstick 605 (3.8gm)",
  //         content: "Beauty People Sheer Color Lipstick 605 (3.8gm)",
  //         verified: true,
  //         image: {
  //           id: "6618ccb5353e9464dff5d524",
  //           url: "https://reviews-ratings-widget-sit.jio.com/dev/ec496909-8d49-4e58-a54b-e7f103bae49d_50..jpeg",
  //           lowResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/7feaf646-41a4-4fc0-984a-3204583d2e00_7..jpeg",
  //           midResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/f4bc51c8-3ad5-4dbc-9146-974d7a3c19f0_63..jpeg",
  //           highResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/ec496909-8d49-4e58-a54b-e7f103bae49d_50..jpeg",
  //           status: "APPROVED",
  //         },
  //         imageList: [
  //           {
  //             id: "6618ccb5353e9464dff5d522",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/b8bf793d-916c-4151-baf1-3326e176faac_89..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/b46ab4dd-244b-4729-977d-aedfda1aff4b_12..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/170b0d79-38bc-4581-9931-f4f4d323a64d_18..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/b8bf793d-916c-4151-baf1-3326e176faac_89..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ccb5353e9464dff5d523",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/5db5a603-2f71-4326-8379-10ff5cec8db7_50..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/fed3a34b-b106-4b89-9cba-0f9099a93828_77..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/c07b3baa-0795-43e5-a9a3-81c4d8d10587_31..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/5db5a603-2f71-4326-8379-10ff5cec8db7_50..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ccb5353e9464dff5d524",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/ec496909-8d49-4e58-a54b-e7f103bae49d_50..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/7feaf646-41a4-4fc0-984a-3204583d2e00_7..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/f4bc51c8-3ad5-4dbc-9146-974d7a3c19f0_63..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/ec496909-8d49-4e58-a54b-e7f103bae49d_50..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ccb5353e9464dff5d525",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/9b462e0c-1e98-48ac-81fc-a17b8f5f4b59_55..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/22342745-c88d-4de1-a77d-332386d73545_75..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/0eb89e77-0185-4817-b1bd-ec9bc6b42e6f_18..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/9b462e0c-1e98-48ac-81fc-a17b8f5f4b59_55..jpeg",
  //             status: "APPROVED",
  //           },
  //         ],
  //         downvoteCount: 0,
  //         upvoteCount: 3,
  //         rating: 4,
  //         anonymous: false,
  //       },
  //       {
  //         id: "6618cc5d1ff5f4712c973a87",
  //         clientId: "tira",
  //         createdBy: "65e004a60b121a2150ae2e80",
  //         productId: "1014128",
  //         alternateCode1: "1014134",
  //         alternateCode2: "7511071",
  //         approvedAt: "2024-04-12T07:00:56.000+00:00",
  //         approvedBy: "657fc2d20eada8bf400bdca4",
  //         createdAt: "2024-04-12T05:55:01.000+00:00",
  //         customerName: "Venkateshwarlu Edukulla",
  //         title: "Beauty People Sheer Color Lipstick 605 (3.8gm)",
  //         content: "Beauty People Sheer Color Lipstick 605 (3.8gm)",
  //         verified: true,
  //         image: {
  //           id: "6618ccb5353e9464dff5d525",
  //           url: "https://reviews-ratings-widget-sit.jio.com/dev/9b462e0c-1e98-48ac-81fc-a17b8f5f4b59_55..jpeg",
  //           lowResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/22342745-c88d-4de1-a77d-332386d73545_75..jpeg",
  //           midResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/0eb89e77-0185-4817-b1bd-ec9bc6b42e6f_18..jpeg",
  //           highResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/9b462e0c-1e98-48ac-81fc-a17b8f5f4b59_55..jpeg",
  //           status: "APPROVED",
  //         },
  //         imageList: [
  //           {
  //             id: "6618ccb5353e9464dff5d522",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/b8bf793d-916c-4151-baf1-3326e176faac_89..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/b46ab4dd-244b-4729-977d-aedfda1aff4b_12..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/170b0d79-38bc-4581-9931-f4f4d323a64d_18..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/b8bf793d-916c-4151-baf1-3326e176faac_89..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ccb5353e9464dff5d523",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/5db5a603-2f71-4326-8379-10ff5cec8db7_50..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/fed3a34b-b106-4b89-9cba-0f9099a93828_77..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/c07b3baa-0795-43e5-a9a3-81c4d8d10587_31..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/5db5a603-2f71-4326-8379-10ff5cec8db7_50..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ccb5353e9464dff5d524",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/ec496909-8d49-4e58-a54b-e7f103bae49d_50..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/7feaf646-41a4-4fc0-984a-3204583d2e00_7..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/f4bc51c8-3ad5-4dbc-9146-974d7a3c19f0_63..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/ec496909-8d49-4e58-a54b-e7f103bae49d_50..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618ccb5353e9464dff5d525",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/9b462e0c-1e98-48ac-81fc-a17b8f5f4b59_55..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/22342745-c88d-4de1-a77d-332386d73545_75..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/0eb89e77-0185-4817-b1bd-ec9bc6b42e6f_18..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/9b462e0c-1e98-48ac-81fc-a17b8f5f4b59_55..jpeg",
  //             status: "APPROVED",
  //           },
  //         ],
  //         downvoteCount: 0,
  //         upvoteCount: 3,
  //         rating: 4,
  //         anonymous: false,
  //       },
  //       {
  //         id: "6618ccdb1ff5f4712c973ae1",
  //         clientId: "tira",
  //         createdBy: "660e688279d66365d09ef631",
  //         productId: "1014128",
  //         alternateCode1: "1014132",
  //         alternateCode2: "7511068",
  //         approvedAt: "2024-04-12T05:59:40.000+00:00",
  //         approvedBy: "657fc2d20eada8bf400bdca4",
  //         createdAt: "2024-04-12T05:59:09.000+00:00",
  //         customerName: "SoundaryaS Gowda",
  //         title: "-.,Overall\":;!?'_@&*(Rating)%//, ₹, +, |Rating",
  //         content: "-.,Overall\":;!?'_@&*(Rating)%//, ₹, +, |Rating",
  //         verified: true,
  //         image: {
  //           id: "6618cdad353e9464dff5d5b2",
  //           url: "https://reviews-ratings-widget-sit.jio.com/dev/879e8eb3-b879-4a35-98cc-44dc80561c96_29..JPG",
  //           lowResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/6513b30e-367a-44ab-89da-31f4c2eacd22_30..JPG",
  //           midResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/f6b2314a-1e3e-45fc-b554-f2a845379024_7..JPG",
  //           highResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/879e8eb3-b879-4a35-98cc-44dc80561c96_29..JPG",
  //           status: "APPROVED",
  //         },
  //         imageList: [
  //           {
  //             id: "6618cdad353e9464dff5d5b2",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/879e8eb3-b879-4a35-98cc-44dc80561c96_29..JPG",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/6513b30e-367a-44ab-89da-31f4c2eacd22_30..JPG",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/f6b2314a-1e3e-45fc-b554-f2a845379024_7..JPG",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/879e8eb3-b879-4a35-98cc-44dc80561c96_29..JPG",
  //             status: "APPROVED",
  //           },
  //         ],
  //         downvoteCount: 0,
  //         upvoteCount: 3,
  //         rating: 4,
  //         anonymous: false,
  //       },
  //       {
  //         id: "6618cf0b353e9464dff5d6ea",
  //         clientId: "tira",
  //         createdBy: "660e688279d66365d09ef631",
  //         productId: "1014128",
  //         alternateCode1: "1014134",
  //         alternateCode2: "7511071",
  //         approvedAt: "2024-04-12T06:06:23.000+00:00",
  //         approvedBy: "657fc2d20eada8bf400bdca4",
  //         createdAt: "2024-04-12T06:05:52.000+00:00",
  //         customerName: "SoundaryaS Gowda",
  //         title: "2nd colour delivered multvarient",
  //         content: "-.,\":;!?'_@&*()%//, ₹, +, |",
  //         verified: true,
  //         image: {
  //           id: "6618cf401ff5f4712c9740b9",
  //           url: "https://reviews-ratings-widget-sit.jio.com/dev/a4f9a5ee-abb6-452b-9511-066309f2b1b8_33..jpeg",
  //           lowResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/a4f9a5ee-abb6-452b-9511-066309f2b1b8_33..jpeg",
  //           midResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/a4f9a5ee-abb6-452b-9511-066309f2b1b8_33..jpeg",
  //           highResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/a4f9a5ee-abb6-452b-9511-066309f2b1b8_33..jpeg",
  //           status: "APPROVED",
  //         },
  //         imageList: [
  //           {
  //             id: "6618cf401ff5f4712c9740b9",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/a4f9a5ee-abb6-452b-9511-066309f2b1b8_33..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/a4f9a5ee-abb6-452b-9511-066309f2b1b8_33..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/a4f9a5ee-abb6-452b-9511-066309f2b1b8_33..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/a4f9a5ee-abb6-452b-9511-066309f2b1b8_33..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618cf401ff5f4712c9740ba",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/45640c14-bc69-4df8-bf41-ae6e35d1de1b_36..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/45640c14-bc69-4df8-bf41-ae6e35d1de1b_36..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/45640c14-bc69-4df8-bf41-ae6e35d1de1b_36..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/45640c14-bc69-4df8-bf41-ae6e35d1de1b_36..jpeg",
  //             status: "APPROVED",
  //           },
  //         ],
  //         downvoteCount: 0,
  //         upvoteCount: 3,
  //         rating: 1,
  //         anonymous: false,
  //       },
  //       {
  //         id: "6618cf0b353e9464dff5d6ea",
  //         clientId: "tira",
  //         createdBy: "660e688279d66365d09ef631",
  //         productId: "1014128",
  //         alternateCode1: "1014134",
  //         alternateCode2: "7511071",
  //         approvedAt: "2024-04-12T06:06:23.000+00:00",
  //         approvedBy: "657fc2d20eada8bf400bdca4",
  //         createdAt: "2024-04-12T06:05:52.000+00:00",
  //         customerName: "SoundaryaS Gowda",
  //         title: "2nd colour delivered multvarient",
  //         content: "-.,\":;!?'_@&*()%//, ₹, +, |",
  //         verified: true,
  //         image: {
  //           id: "6618cf401ff5f4712c9740ba",
  //           url: "https://reviews-ratings-widget-sit.jio.com/dev/45640c14-bc69-4df8-bf41-ae6e35d1de1b_36..jpeg",
  //           lowResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/45640c14-bc69-4df8-bf41-ae6e35d1de1b_36..jpeg",
  //           midResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/45640c14-bc69-4df8-bf41-ae6e35d1de1b_36..jpeg",
  //           highResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/45640c14-bc69-4df8-bf41-ae6e35d1de1b_36..jpeg",
  //           status: "APPROVED",
  //         },
  //         imageList: [
  //           {
  //             id: "6618cf401ff5f4712c9740b9",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/a4f9a5ee-abb6-452b-9511-066309f2b1b8_33..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/a4f9a5ee-abb6-452b-9511-066309f2b1b8_33..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/a4f9a5ee-abb6-452b-9511-066309f2b1b8_33..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/a4f9a5ee-abb6-452b-9511-066309f2b1b8_33..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6618cf401ff5f4712c9740ba",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/45640c14-bc69-4df8-bf41-ae6e35d1de1b_36..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/45640c14-bc69-4df8-bf41-ae6e35d1de1b_36..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/45640c14-bc69-4df8-bf41-ae6e35d1de1b_36..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/45640c14-bc69-4df8-bf41-ae6e35d1de1b_36..jpeg",
  //             status: "APPROVED",
  //           },
  //         ],
  //         downvoteCount: 0,
  //         upvoteCount: 3,
  //         rating: 1,
  //         anonymous: false,
  //       },
  //       {
  //         id: "6617bab9592d46680e1d2d6b",
  //         clientId: "tira",
  //         createdBy: "661775b423652fe698085e1d",
  //         productId: "1014128",
  //         alternateCode1: "1014132",
  //         alternateCode2: "7511068",
  //         approvedAt: "2024-04-11T10:29:53.000+00:00",
  //         approvedBy: "657fc2d20eada8bf400bdca4",
  //         createdAt: "2024-04-11T10:29:27.000+00:00",
  //         customerName: "Abhishek Babdi",
  //         title: "https://www.tiraz0.de/product/beauty-people-sheer-",
  //         content:
  //           "https://www.tiraz0.de/product/beauty-people-sheer-color-lipstick-512-38gm-jgzwkhs4bufg",
  //         verified: true,
  //         image: {
  //           id: "6617bb876737521cf9517e14",
  //           url: "https://reviews-ratings-widget-sit.jio.com/dev/dc2afe8b-f0db-4d21-8ff0-e2ea34e9210a_19..png",
  //           lowResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/dc2afe8b-f0db-4d21-8ff0-e2ea34e9210a_19..png",
  //           midResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/dc2afe8b-f0db-4d21-8ff0-e2ea34e9210a_19..png",
  //           highResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/dc2afe8b-f0db-4d21-8ff0-e2ea34e9210a_19..png",
  //           status: "APPROVED",
  //         },
  //         imageList: [
  //           {
  //             id: "6617bb876737521cf9517e14",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/dc2afe8b-f0db-4d21-8ff0-e2ea34e9210a_19..png",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/dc2afe8b-f0db-4d21-8ff0-e2ea34e9210a_19..png",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/dc2afe8b-f0db-4d21-8ff0-e2ea34e9210a_19..png",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/dc2afe8b-f0db-4d21-8ff0-e2ea34e9210a_19..png",
  //             status: "APPROVED",
  //           },
  //         ],
  //         downvoteCount: 0,
  //         upvoteCount: 3,
  //         rating: 4,
  //         anonymous: false,
  //       },
  //       {
  //         id: "6617bdc3ba7a6f3c87460a6a",
  //         clientId: "tira",
  //         createdBy: "661775b423652fe698085e1d",
  //         productId: "1014128",
  //         alternateCode1: "1014134",
  //         alternateCode2: "7511071",
  //         approvedAt: "2024-04-11T10:40:03.000+00:00",
  //         approvedBy: "657fc2d20eada8bf400bdca4",
  //         createdAt: "2024-04-11T10:39:35.000+00:00",
  //         customerName: "Abhishek Babdi",
  //         title: "2nd colour lipstic_multivarient",
  //         content: "2nd colour lipstic_multivarient",
  //         verified: true,
  //         image: {
  //           id: "6617bde76737521cf9517eb4",
  //           url: "https://reviews-ratings-widget-sit.jio.com/dev/31a25894-fe84-439f-924f-c091826dea45_26..jpeg",
  //           lowResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/4adfe6d8-8a60-47f9-8b7e-82ad4a13a5cd_8..jpeg",
  //           midResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/b6580b65-77f7-42bc-b90d-fb5099f917c1_29..jpeg",
  //           highResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/31a25894-fe84-439f-924f-c091826dea45_26..jpeg",
  //           status: "APPROVED",
  //         },
  //         imageList: [
  //           {
  //             id: "6617bde76737521cf9517eb4",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/31a25894-fe84-439f-924f-c091826dea45_26..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/4adfe6d8-8a60-47f9-8b7e-82ad4a13a5cd_8..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/b6580b65-77f7-42bc-b90d-fb5099f917c1_29..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/31a25894-fe84-439f-924f-c091826dea45_26..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6617bde76737521cf9517eb5",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/e66b7e41-ba02-4abc-ac97-b8a8a2b995e0_46..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/e66b7e41-ba02-4abc-ac97-b8a8a2b995e0_46..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/e66b7e41-ba02-4abc-ac97-b8a8a2b995e0_46..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/e66b7e41-ba02-4abc-ac97-b8a8a2b995e0_46..jpeg",
  //             status: "APPROVED",
  //           },
  //         ],
  //         downvoteCount: 0,
  //         upvoteCount: 5,
  //         rating: 5,
  //         anonymous: false,
  //       },
  //       {
  //         id: "6617bdc3ba7a6f3c87460a6a",
  //         clientId: "tira",
  //         createdBy: "661775b423652fe698085e1d",
  //         productId: "1014128",
  //         alternateCode1: "1014134",
  //         alternateCode2: "7511071",
  //         approvedAt: "2024-04-11T10:40:03.000+00:00",
  //         approvedBy: "657fc2d20eada8bf400bdca4",
  //         createdAt: "2024-04-11T10:39:35.000+00:00",
  //         customerName: "Abhishek Babdi",
  //         title: "2nd colour lipstic_multivarient",
  //         content: "2nd colour lipstic_multivarient",
  //         verified: true,
  //         image: {
  //           id: "6617bde76737521cf9517eb5",
  //           url: "https://reviews-ratings-widget-sit.jio.com/dev/e66b7e41-ba02-4abc-ac97-b8a8a2b995e0_46..jpeg",
  //           lowResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/e66b7e41-ba02-4abc-ac97-b8a8a2b995e0_46..jpeg",
  //           midResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/e66b7e41-ba02-4abc-ac97-b8a8a2b995e0_46..jpeg",
  //           highResUrl:
  //             "https://reviews-ratings-widget-sit.jio.com/dev/e66b7e41-ba02-4abc-ac97-b8a8a2b995e0_46..jpeg",
  //           status: "APPROVED",
  //         },
  //         imageList: [
  //           {
  //             id: "6617bde76737521cf9517eb4",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/31a25894-fe84-439f-924f-c091826dea45_26..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/4adfe6d8-8a60-47f9-8b7e-82ad4a13a5cd_8..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/b6580b65-77f7-42bc-b90d-fb5099f917c1_29..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/31a25894-fe84-439f-924f-c091826dea45_26..jpeg",
  //             status: "APPROVED",
  //           },
  //           {
  //             id: "6617bde76737521cf9517eb5",
  //             url: "https://reviews-ratings-widget-sit.jio.com/dev/e66b7e41-ba02-4abc-ac97-b8a8a2b995e0_46..jpeg",
  //             lowResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/e66b7e41-ba02-4abc-ac97-b8a8a2b995e0_46..jpeg",
  //             midResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/e66b7e41-ba02-4abc-ac97-b8a8a2b995e0_46..jpeg",
  //             highResUrl:
  //               "https://reviews-ratings-widget-sit.jio.com/dev/e66b7e41-ba02-4abc-ac97-b8a8a2b995e0_46..jpeg",
  //             status: "APPROVED",
  //           },
  //         ],
  //         downvoteCount: 0,
  //         upvoteCount: 5,
  //         rating: 5,
  //         anonymous: false,
  //       },
  //     ],
  //     page: {
  //       size: 30,
  //       current: 0,
  //       hasNext: false,
  //     },
  //   },
  // })

  return apiClient.get(endpoint, { params: queryParam })
}

export function apiAddReview(requestData) {
  const endpoint = API_URLS.getAddReviewUrl()

  return apiClient.post(endpoint, requestData)
}

export function apiEditReview(reviewId, requestData) {
  const endpoint = API_URLS.getEditReviewUrl(reviewId)

  return apiClient.put(endpoint, requestData)
}

export function apiUpdateVoteCount(requestData) {
  const endpoint = API_URLS.getReviewUpdateVoteCountUrl()

  return apiClient.put(endpoint, requestData)
}

export function apiGetSignedImageUrl(requestData) {
  const endpoint = API_URLS.getSignedImageUrl()

  return apiClient.post(endpoint, requestData)
}

export function apiUploadImgToGeneratedSignedUrl(endpoint, formData) {
  // Backend api is returning the endpoint which we need to use, so no need to create endpoint URL here
  return apiClient.put(endpoint, formData)
}
